const BaseView = require('components-framework/view/base.view');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const baggageCollectionBuilder = require('../../../../../webapp/static-content/_versionedByRelease_/js/modules/builders/baggages').getInstance();
const baggagesManagerMixin = require('../../../../../webapp/static-content/_versionedByRelease_/js/modules/mixins/baggages_manager.mixin');
const baggagesObserverMixin = require('../../../../../webapp/static-content/_versionedByRelease_/js/modules/mixins/baggages_observer.mixin');
const baggagePassengerFactory = require('components/bags_and_seats/baggage/baggage_passenger/js/main');
const baggageSelectorFactory = require('components/bags_and_seats/baggage/baggage_selector/js/main');
const UiDataBuilder = require('../ui_data_builders/ui_data_builder');
const trackingUtils = require('../tracking/utils').default;
const store = require('od-modules/secure_store/store');
const {SET_BAG_MERCHANDISE_INFO} = require('od-modules/secure_store/actions');
const checkedBagsOneClickUtils = require('../../../utils/checked_bags_one_click');

const PROMO_BADGE_PREFIX = 'promoBadge';
const BAGS_VISIBLE_ITEMS_ROW = 3;

const getPassengerMainTemplateData = (baggageInformation = []) => {
    const mainTemplateData = [];
    baggageInformation.forEach((baggageInfo, index) => {
        if (baggageInfo) {
            const paxRowClasses = index > 0
                ? 'od-baggage-wrapper-pax-row'
                : '';

            mainTemplateData.push({
                index,
                paxRowClasses,
            });
        }
    });

    return mainTemplateData;
};

export default withCachedSelectors(BaseView.extend(baggagesObserverMixin.extend(baggagesManagerMixin.extend({
    baggagePassengers: {},
    uiDataBuilder: new UiDataBuilder(),
    selectors: {
        baggageWrapperMessage: '.baggage_wrapper_info_message',
        baggageWrapperSavedAmountInfo: '.baggage_wrapper_saved_amount_info',
        baggageWrapperDefault: '.baggage_wrapper_default',
        baggageWrapperOneClick: '.baggage_wrapper_one_click',
        checkedBagsOneClickLoadMore: '.checked_bags_one_click_load_more',
    },

    initialize(options) {
        this.isSelected = false;
        this.updateProduct = Odigeo._.get(options, 'props.updateProduct');
        this.updateChildContainerData = Odigeo._.get(options, 'props.updateChildContainerData');
        this.updateChildContainerFooter = Odigeo._.get(options, 'props.updateChildContainerFooter');
        this.onParent = Odigeo._.get(options, 'props.onParent');

        this.bindEvents();
        this.triggerNagSubscribeEvent();

        baggageCollectionBuilder.buildCollection();
    },

    evenUpSelection(handlerCallback = () => {}) {
        this.evenUpBaggageSelection();
        handlerCallback();
    },

    triggerNagSubscribeEvent: function() {
        const baggageInfo = {
            widgetId: 'baggage-selection',
            details: {
                isEnabled: false,
            },
        };
        Odigeo.trigger('baggage-wrapper:nagSubscribe', baggageInfo);
    },

    bindEvents() {
        this.listenTo(this.model, 'change:baggageInformation', this.render);
        this.suscribeBaggagesCollectionEvents();
        Odigeo.on('baggagesObserver:onBaggageChange', (event) => {
            if (event.isUserAction) {
                this.oneClickGroupSelected = null;
                this.renderWrapperMessage(this.getBaggageUIData());
            }
        });
    },

    createBaggagePassenger(baggageRows, requestType, passengerId) {
        return baggagePassengerFactory.create({
            id: `baggage-passenger-${passengerId}`,
            ancillaryContainer: this.el,
            baggageRows,
            requestType,
            passengerId,
            autoSelectionAvailable: this.autoSelectionAvailable && !this.isCheckedBagsOneClickInScope,
            baggageSelector: this.baggageSelector,
            onParent: this.onParent,
        });
    },

    createBaggageSelector() {
        return baggageSelectorFactory.create({
            id: `baggage-selector-wrapper`,
            ancillaryContainer: this.el,
            primeInfo: this.getPrimeInfo(),
            onParent: this.onParent,
        });
    },

    onBaggageChange() {
        const baggageUIData = this.getBaggageUIData();
        this.updateProduct(baggageUIData);
        this.updateChildContainerFooter();
        this.renderWrapperMessage(baggageUIData);
        this.renderWrapperSavedAmountInfo(baggageUIData);

        const isCheckedBagsOneClick = this.hasNoBagBeenSelected() && this.isCheckedBagsOneClickInScope;
        this.toggleCheckedBagsOneClick(isCheckedBagsOneClick);
    },

    toggleCheckedBagsOneClick(show = true) {
        const $baggageWrapperDefault = this.$el.find(this.selectors.baggageWrapperDefault);
        const $baggageWrapperOneClick = this.$el.find(this.selectors.baggageWrapperOneClick);
        $baggageWrapperDefault.toggleClass('odf-hidden', show);
        $baggageWrapperOneClick.toggleClass('odf-hidden', !show);
        this.isCheckedBagsOneClick = show;
    },

    render() {
        const baggageInformation = this.model.get('baggageInformation');
        const baggageUIData = this.getBaggageUIData();
        this.isCheckedBagsOneClick = this.hasNoBagBeenSelected() && this.isCheckedBagsOneClickInScope;
        this.$el.html(this.templates.main({
            passengers: getPassengerMainTemplateData(baggageInformation),
            isCheckedBagsOneClick: this.isCheckedBagsOneClick,
        }));
        this.updateChildContainerData({
            child: baggageUIData.child,
            productAvailable: baggageUIData.productAvailable,
            enableConfirmButton: baggageUIData.enableConfirmButton,
        });

        if (this.isCheckedBagsOneClickInScope) {
            this.renderCheckedBagsOneClick();
            this.toggleCheckedBagsOneClick(this.hasNoBagBeenSelected() && this.isCheckedBagsOneClickInScope);
        }

        this.renderWrapperMessage(baggageUIData);
        this.renderWrapperSavedAmountInfo(baggageUIData);
    },

    renderCheckedBagsOneClick() {
        const {isPrimeView} = this.getPrimeInfo() || {};
        const $baggageWrapperOneClick = this.$el.find(this.selectors.baggageWrapperOneClick);
        $baggageWrapperOneClick.html(this.templates.checkedBagsOneClick({
            keys: this.keys,
            oneClickGroups: this.oneClickGroups.options,
            oneClickVisibleItems: this.oneClickVisibleItems,
            primePriceExplained: this.keys.oneclickPrimePrice,
            priceExplained: this.keys.oneclickNormalPrice,
            isPrimeView,
        }));
    },

    onLoadMore() {
        this.oneClickVisibleItems = Math.min(this.oneClickVisibleItems + BAGS_VISIBLE_ITEMS_ROW, this.oneClickGroups.options.length);
        this.renderCheckedBagsOneClick();
        const {tracking, params} = this.getTrackingData('onLoadMoreClick');
        tracking.onClickOneClickMoreOptions(params);
    },

    onAddOneClickBag(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        const index = $(evt.currentTarget).data('index');
        const selectedGroup = this.oneClickGroups.selection(index);
        this.oneClickGroupSelected = selectedGroup;
        selectedGroup.group.forEach((selectionItem) => {
            this.updateAllMatchingBaggagesOptions(
                {
                    idRow: selectionItem.baggageDescriptor.idRow,
                    pieces: selectionItem.baggageDescriptor.pieces,
                    kilos: selectionItem.baggageDescriptor.kilos,
                    price: selectionItem.baggageDescriptor.price,
                },
                null,
                {avoidNags: true},
            );
        });
        const {tracking, params} = this.getTrackingData('onSelectOneClick');
        tracking.onClickOneClickOption({...params, pos: index + 1, sel: selectedGroup.pieces});
    },

    renderWrapperMessage(baggageUIData = {}) {
        const {isSelected} = baggageUIData;
        const informativeMessageData = isSelected
            ? Odigeo._.get(baggageUIData, 'child.selected.informativeMessage')
            : Odigeo._.get(baggageUIData, 'child.base.informativeMessage');
        const $informativeMessage = this.$el.find(this.selectors.baggageWrapperMessage);
        $informativeMessage.toggleClass('odf-hidden', !informativeMessageData);

        if (informativeMessageData) {
            const {
                messageAdditionalClasses,
                messageIcon,
                messageTitle,
                messageSubtitle,
                color,
            } = informativeMessageData;
            const template = this.templates.message;
            const isCheckedBagsOneClickMessage = Boolean(this.oneClickGroupSelected) &&
                checkedBagsOneClickUtils.isDifferentSelection(this.oneClickGroupSelected);
            $informativeMessage.html(template({
                isCheckedBagsOneClickMessage,
                checkedBagsOneClickMessage: this.keys.bagsCostEffectiveMessage,
                messageAdditionalClasses,
                messageIcon,
                messageTitle,
                messageSubtitle,
                color,
            }));
        }
    },

    renderWrapperSavedAmountInfo(baggageUIData = {}) {
    },
    onCollectionBuilt(baggageInformation) {
        this.isCheckedBagsOneClickInScope = checkedBagsOneClickUtils.isInScope(baggageInformation);
        if (this.isCheckedBagsOneClickInScope) {
            try {
                this.oneClickGroups = checkedBagsOneClickUtils.getOneClickGroups(baggageInformation[0], {
                    isAnItineraryTrip: baggageCollectionBuilder.isItineraryTrip(),
                });
                this.oneClickVisibleItems = Math.min(BAGS_VISIBLE_ITEMS_ROW, this.oneClickGroups.options.length);
            } catch (e) {
                this.isCheckedBagsOneClickInScope = false;
                // eslint-disable-next-line no-restricted-properties
                console.error(e);
            }
        }

        this.model.set('baggageInformation', baggageInformation);

        this.autoSelectionAvailable = this.doBaggageAllowAutoselection();

        if (!this.baggageSelector && this.hasAnySelectableBaggage()) {
            this.baggageSelector = this.createBaggageSelector();
        }

        this.baggagePassengers = baggageInformation.reduce((acc, passengerData, passengerId) => {
            const requestType = Odigeo._.isUndefined(passengerData) ? '' : passengerData.searchRequestType;

            const baggageRows = this.getBaggagePassengerComposedRowsInfo(passengerId);
            acc[passengerId] = this.createBaggagePassenger(baggageRows, requestType, passengerId);
            return acc;
        }, {});

        const baggageUIData = this.getBaggageUIData();
        this.setMerchandisingInfo(baggageUIData);
        this.updateProduct(baggageUIData);
        Odigeo.trigger('baggage-wrapper:notifyNagProductEnabled', 'baggage-selection', true);
    },

    setMerchandisingInfo(baggageUIData = {}) {
        const primeInfo = this.getPrimeInfo();
        const {isPrimeView} = primeInfo;
        const displayed = baggageUIData.enablePromoBadge
            && this.shouldDisplayPromotionBadge()
            && !isPrimeView;

        store.dispatch({type: SET_BAG_MERCHANDISE_INFO, entry: {
            discount: baggageCollectionBuilder.getDiscountPercentage() || 0,
            displayed,
        }});
    },

    getIncludedBaggageInformativeMessage() {
        const fistIncludedOption = Odigeo._.first(this.getBaggageIncludedOptions());
        const kilos = fistIncludedOption ? fistIncludedOption.get('kilos') : 0;
        const pieces = fistIncludedOption ? fistIncludedOption.get('pieces') : 0;

        if (this.hasTrainSegment() && !this.isPureTrain()) {
            return Odigeo.Utils.pluralizeAll(this.keys.cardMessageIncludedMixed, pieces);
        }

        return kilos > 0 ?
            Odigeo.Utils.pluralizeAll(this.keys.cardMessageIncludedKilos, pieces, kilos) :
            Odigeo.Utils.pluralizeAll(this.keys.cardMessageIncluded, pieces);
    },

    getBaggageUIData() {
        const isSelected = !this.hasNoBagBeenSelected();
        const scenarioData = this.getBaggageUIDataByScenario();
        const fee = this.getSelectedBaggageAverageFee();
        const primeFee = this.getPrimePriceFee();
        const promoBadgeData = this.getPromoBadgeData(scenarioData.enablePromoBadge);
        const vinData = this.getVinFlightData();
        const primeData = this.getPrimeData();
        const {isPrimeView} = this.getPrimeInfo();

        return Odigeo._.merge(
            {
                isSelected,
                fee: isPrimeView ? primeFee : fee,
            },
            scenarioData,
            promoBadgeData,
            primeData,
            vinData,
        );
    },

    getVinFlightData() {
        const isVinFlight = Odigeo.Session.get('isVinFlight') === 'true';
        const hasIncludedOrSelectable = this.hasIncludedBaggage() || this.hasSelectableRowsNoExtraBag();
        return hasIncludedOrSelectable && isVinFlight ? this._getVinFlightData() : {};
    },

    _getVinFlightData() {
        const allRowsIncludedAndNoExtra = this.hasAllRowsIncludedBaggages() && !this.hasAnySelectableBaggage();
        const includedBaggageInformativeMessage = this.getIncludedBaggageInformativeMessage();
        return this.uiDataBuilder.isVinFlight(this.keys, {
            allRowsIncludedAndNoExtra,
            includedBaggageInformativeMessage,
        });
    },

    getPrimeData() {
        const {isPrimeView, isPrimeUser, discountPercentage, discountAmount, memberName} = this.getPrimeInfo();
        let primeData = {};

        if (isPrimeView) {
            const primeInfo = {
                savedAmount: this.getPrimeSavedAmount(),
                discountPercentage,
                discountAmount,
                memberName,
            };

            if (isPrimeUser) {
                primeData = this.uiDataBuilder.primeRepeat(this.keys, this.templates, primeInfo);
            } else {
                primeData = this.uiDataBuilder.primeAcquisition(this.keys, this.templates, primeInfo);
            }
        }

        return primeData;
    },

    getBaggageUIDataByScenario() {
        const someRowsIncluded = this.hasIncludedBaggage() && !this.hasAllRowsIncludedBaggages();
        const noIncludedAndSelectable = !this.hasIncludedBaggage() && this.hasSelectableRowsNoExtraBag();
        const noIncludedAndNoSelectable = !this.hasIncludedBaggage() && !this.hasSelectableRowsNoExtraBag();
        const allRowsIncludedAndExtra = this.hasAllRowsIncludedBaggages() && this.hasAnySelectableBaggage();
        const allRowsIncludedAndNoExtra = this.hasAllRowsIncludedBaggages() && !this.hasAnySelectableBaggage();
        const someRowsIncludedAndSelectable = someRowsIncluded && this.hasAnySelectableBaggage();
        const someRowsIncludedAndNoSelectable = someRowsIncluded && !this.hasAnySelectableBaggage();
        const isPureTrain = this.isPureTrain();

        let data = {};

        if (isPureTrain) {
            if (this.hasAllRowsIncludedBaggages()) {
                const firstIncludedOption = Odigeo._.first(this.getBaggageIncludedOptions());
                const pieces = firstIncludedOption ? firstIncludedOption.get('pieces') : 0;
                data = this.uiDataBuilder.trainStandalone(this.keys, pieces);
            } else if (someRowsIncludedAndNoSelectable) {
                data = this.uiDataBuilder.trainStandaloneSomeIncluded(this.keys);
            } else if (!this.hasIncludedBaggage() && !this.hasAnySelectableBaggage()) {
                data = this.uiDataBuilder.trainStandaloneNoneIncluded(this.keys);
            }
        } else if (noIncludedAndSelectable) {
            data = this.uiDataBuilder.noIncludedAndSelectable(this.keys);
        } else if (noIncludedAndNoSelectable) {
            data = this.uiDataBuilder.noIncludedAndNoSelectable(this.keys);
        } else if (allRowsIncludedAndExtra) {
            const includedBaggageInformativeMessage = this.getIncludedBaggageInformativeMessage();
            data = this.uiDataBuilder.allRowsIncludedAndExtra(this.keys, includedBaggageInformativeMessage);
        } else if (allRowsIncludedAndNoExtra) {
            const includedBaggageInformativeMessage = this.getIncludedBaggageInformativeMessage();
            data = this.uiDataBuilder.allRowsIncludedAndNoExtra(this.keys, includedBaggageInformativeMessage);
        } else if (someRowsIncludedAndSelectable) {
            const includedBaggageInformativeMessage = this.getIncludedBaggageInformativeMessage();
            data = this.uiDataBuilder.someRowsIncludedAndSelectable(this.keys, includedBaggageInformativeMessage);
        } else if (someRowsIncludedAndNoSelectable) {
            data = this.uiDataBuilder.someRowsIncludedAndNoSelectable(this.keys);
        }

        return data;
    },

    getPromoBadgeData(enablePromoBadge) {
        const primeInfo = this.getPrimeInfo();
        const {isPrimeView} = primeInfo;
        const promoBadgeData = this.uiDataBuilder.promoBadge(this.keys, primeInfo);
        const promoBadgeUIData = this._getPromoBadgeData(promoBadgeData);
        const isPromoBadgeAvailable = enablePromoBadge
            && (this.shouldDisplayPromotionBadge() || this.shouldDisplayPrimeBadge(isPrimeView));
        if (Odigeo.AB.isNegativePrimeMarkupBagsSeatsDesktop && this.shouldDisplayPrimeBadge(isPrimeView)) {
            Odigeo.trigger('baggage-wrapper:primeMerchandisingBadgeDisplayed');
        }

        return isPromoBadgeAvailable ? promoBadgeUIData : {};
    },

    getDiscountDisplayed(discountPercentage, discountAmount) {
        if (!discountPercentage) {
            return '';
        }

        return discountAmount > 0 ?
            Odigeo.Utils.formatCurrency(discountAmount, {...Odigeo.Utils.Currency, decimalPlaces: 0})
            : `-${discountPercentage}%`;
    },

    _getPromoBadgeData(data) {
        const primeInfo = this.getPrimeInfo();
        const {isPrimeView, discountPercentage, discountAmount} = primeInfo;
        const badges = data.promoBadgeConfig || [];
        const badge = this.getPromoBadge(badges);
        const discount = isPrimeView
            ? discountPercentage
            : this.getPromoBadgeDiscount(badge);
        const hasDiscount = discount > 0;
        let content = '';
        let uiData = {};

        if (hasDiscount) {
            const key = badge.name;
            const templateName = `${PROMO_BADGE_PREFIX}${Odigeo._.capitalize(key)}`;
            const template = this.templates[templateName];
            const cheapestBagOption = baggageCollectionBuilder.getCheapestSelectableOption();
            const isItineraryTrip = baggageCollectionBuilder.isItineraryTrip();
            const sectionsIncluded = isItineraryTrip ? 2 : 1;
            const primePriceFromLabel = this.shouldDisplayPrimeBadge(isPrimeView) && cheapestBagOption ?
                this.templates.primePriceFromLabel({
                    keys: this.keys,
                    cheapestBagOption: {
                        price: cheapestBagOption.get('price') / sectionsIncluded,
                        primePrice: cheapestBagOption.get('primePrice') / sectionsIncluded,
                    },
                })
                : '';
            content = template ? template({
                discountDisplayed: this.getDiscountDisplayed(discount, discountAmount),
                ...badge,
                primeInfo,
                keys: this.keys,
            }) : content;

            uiData = Odigeo._.merge({
                promoBadge: {
                    content,
                },
                primePriceFromLabel,
            }, data);
        }

        return uiData;
    },

    getPromoBadgeDiscount(promoBadgeData = {}) {
        if (this.getDiscountFigure() === null) {
            const discountFigure = +promoBadgeData.discountFigure || 0;
            this.setDiscountFigure(discountFigure);
        }
        return baggageCollectionBuilder.getDiscountPercentage();
    },
    getPromoBadge(promoBadgeData = []) {
        return promoBadgeData.reduce((accumulator, currentValue) =>
            (currentValue.abTest || Odigeo._.isEmpty(accumulator)) ? currentValue : accumulator, {});
    },

    getTrackingData(event) {
        return trackingUtils.getTrackingData.call(this, event);
    },
}))));
